// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-components-post-js": () => import("/app/src/components/Post.js" /* webpackChunkName: "component---src-components-post-js" */),
  "component---src-components-tag-page-js": () => import("/app/src/components/TagPage.js" /* webpackChunkName: "component---src-components-tag-page-js" */),
  "component---src-components-tech-radar-tech-radar-js": () => import("/app/src/components/TechRadar/TechRadar.js" /* webpackChunkName: "component---src-components-tech-radar-tech-radar-js" */),
  "component---src-components-category-page-js": () => import("/app/src/components/CategoryPage.js" /* webpackChunkName: "component---src-components-category-page-js" */),
  "component---src-pages-404-js": () => import("/app/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/app/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/app/.cache/data.json")

